import { IData } from '@/types/globalTypes';
import { IBaseOffice2, IRegion } from '@/store/bank';
import { IMenuItem, IPrivileges as IPrivilegesUser } from '@/store/user';

//https://back.test.ros.ifrbanking.ru/api/application/find/ce54544f-ba96-4922-998e-d8e2e38fd1de
export class Okved implements IOkved {
  'id': number;
  'code': string;
  'name': string;
  'integrumCode': string;
  'fullName': string;
  constructor({ id = 0, code = '', name = '', integrumCode = '', fullName = '' } = {}) {
    this.id = id;
    this.code = code;
    this.name = name;
    this.integrumCode = integrumCode;
    this.fullName = fullName;
  }
}
export interface IOkved {
  id: number;
  code: string;
  name: string;
  integrumCode: string;
  fullName: string;
}

export interface IOkato {
  id: number;
  code: string;
  name: string;
  integrumCode: string;
  fullName: string;
  hibernateLazyInitializer: object;
}
export class Okato implements IOkato {
  'id': number;
  'code': string;
  'name': string;
  'integrumCode': string;
  'fullName': string;
  hibernateLazyInitializer: object;

  constructor({ id = 0, code = '', name = '', integrumCode = '', fullName = '', hibernateLazyInitializer = {} } = {}) {
    this.id = id;
    this.code = code;
    this.name = name;
    this.integrumCode = integrumCode;
    this.fullName = fullName;
    this.hibernateLazyInitializer = hibernateLazyInitializer;
  }
}
interface IOwnershipForm {
  id: number;
  name?: string;
  integrmumCode?: string;
}
/** Офис заявки в карточке: как IBaseOffice2, но korrLocation в camelCase (в справочнике office - korrlocation) */
interface IBankoffice extends Omit<IBaseOffice2, 'korrlocation'> {
  korrLocation: string;
  region: IRegion;
  num: number;
  placeResolution?: string;
  placeSigning?: string;
  fullNameEmpBank?: string;
  positionEmpBank?: string;
  numberProxyEmpBank?: string;
  dateProxyEmpBank?: string;
  additionalInfo?: string;
}
interface IStakeholders {
  id: IStakeholdersId;
  objecttype: string;
  founder: boolean;
  chief: boolean;
  integrum: boolean;
  ceo: boolean;
  nonResident: boolean;
  // у участника-физлица без доли - нет
  share?: number;
  amountShare?: number;
  country?: string;
  rapf: boolean;
  // у участника - либо юрлицо, либо физлицо
  legalEntity?: ILegalEntity;
  address?: IAddress;
  individual?: IIndividual;
}
interface IStakeholdersId {
  applicationId: string;
  objectId: string;
}
interface ILegalEntity {
  id: string;
  name: string;
  inn: string;
  kpp: string;
  ogrn: string;
  hibernateLazyInitializer: object;
}
/** Адрес участника: заполненность зависит от источника (DaData, ручной ввод) - кроме id всё необязательно */
interface IAddress {
  id: string;
  index?: string;
  country?: string;
  area?: string;
  city?: string;
  fias?: string;
  kladr?: string;
  /** на stage.cred приходит строкой */
  source?: IData | string;
}
interface IIndividual {
  id: string;
  fio: string;
  name: string;
  surname: string;
  parname: string;
  inn: string;
  dateBirth: string;
  passport: IPassport;
  position: string;
  chief: boolean;
  initials: string;
  initialsShort: string;
}
interface IPassport {
  id: string;
  issuedate: string;
  unitcode: string;
  docnumber: string;
  docserial: string;
  registeraddress: string;
  fullAddress: IData;
}
interface IType {
  id: number;
  code: string;
  name: string;
  numberPrefix: string;
}
class Type implements IType {
  'id' = 0;
  'code' = '';
  'name' = '';
  'numberPrefix' = '';
}
interface IStatusHistoryList {
  id: IStatusHistoryListId;
  initiator: string;
  role: string;
  comment: string;
  datetime: string;
  status: IStatus;
}
interface IStatusHistoryListId {
  applicationId: string;
  status: IStatus;
  /** в id - dateTime, а у самой записи - datetime */
  dateTime: string;
}
/** Статус заявки в карточке (application/find: actualStatus, actualRealStatus) - поля в camelCase */
export interface IStatus {
  id: number;
  code: string;
  name: string;
  info: string;
  color: string;
  message: string;
  nameLkk: string;
  /** нет у статусов в statusHistoryList */
  comment?: string;
  showFinalResult: boolean;
  canRequestDocs: boolean;
  annulate_app: boolean;
  hibernateLazyInitializer?: object;
  roleEditors: IRoleEditor[];
  docUploadBan: boolean;
}

/** Роль-редактор статуса (actualStatus.roleEditors): меню без children, applicationBlock - id блоков */
export interface IRoleEditor {
  id: number;
  active: boolean;
  name: string;
  orderPosition: number;
  delete: boolean;
  typeBan: boolean;
  privileges: IPrivilegesUser[];
  menuTree: IMenuItem[];
  /** Jackson identity: блок при первом упоминании - объект, дальше - только его id */
  applicationBlock: (
    | number
    | {
        id: number;
        orderNum: number;
        code: string;
        name: string;
        active: boolean;
        parent?: unknown;
        children?: unknown[];
      }
  )[];
  defaultPage?: number;
  hibernateLazyInitializer?: object;
}

/** Статус в строке журнала заявок (application/all) - только эти поля */
export type IStatusShort = Pick<IStatus, 'id' | 'name' | 'code' | 'info' | 'color'>;

/** Статус из справочника GET status - другие имена полей: строчными (showfinalresult), editors вместо roleEditors */
export interface IStatusDict {
  id: number;
  code: string;
  name: string;
  info: string;
  showfinalresult: boolean;
  canrequestdocs: boolean;
  color: string;
  message: string;
  nameLkk: string;
  docUploadBan: boolean;
  editors: number[];
  annulate_app: boolean;
}
class Status implements IStatus {
  // @ts-ignore
  roleEditors: IRoleEditor[] | undefined;
  id = 0;
  code = '';
  name = '';
  info = '';
  color = '';
  message = '';
  nameLkk = '';
  comment = '';
  showFinalResult = false;
  canRequestDocs = false;
  annulate_app = false;
  hibernateLazyInitializer = {};
}

export interface ISignatures {
  id: IsignatureId;
  signed: boolean;
  comment: string;
  role: IRoleEditor;
  lkbEmployee: ILkbEmployee;
  resoultion: string;
}
interface IsignatureId {
  applicationId: string;
  /** есть не у всех подписей */
  employeeId?: string;
  dateTime: string;
}
interface ILkbEmployee {
  id: string;
  userid: string;
  surname: string;
  name: string;
  parname: string;
  dateDocument?: string;
  numberDocument: string;
  nameEmployee: string;
  email: string;
  deleted: boolean;
  revokeFromApplication: boolean;
  signContract: boolean;
  /** строка (ФИО), раньше по ошибке был boolean */
  fio: string;
  hibernateLazyInitializer?: object;
}

interface IMetaInfoList {
  id: IMetaInfoListId;
  /** приходит строкой */
  value: string;
}
interface IMetaInfoListId {
  applicationId: string;
  key: string;
}

/** Клиент заявки. У заявок без клиента ЛКК приходят только phone, email, active, deleted, fio, name */
export interface IClient {
  id?: string;
  objecttype?: string;
  number?: number;
  createdate?: string;
  phone: string;
  email: string;
  contactfio?: string;
  additionalNumbers?: { id?: string; phone: string; active: boolean }[];
  active: boolean;
  deleted: boolean;
  objectId?: string;
  individual?: IIndividual2;
  /** агент клиента - если клиент пришёл через агента */
  agent?: IAgent;
  fio: string;
  name: string;
}
class Client implements IClient {
  'id' = '';
  'objecttype' = '';
  'number' = 0;
  'createdate' = '';
  'phone' = '';
  'email' = '';
  'contactfio' = '';
  'additionalNumbers' = [];
  'active' = false;
  'deleted' = false;
  'objectId' = '';
  'individual' = <IIndividual2>new Individual2();
  'fio' = '';
  'name' = '';
}

export interface IAgent {
  /** есть в карточке заявки (application.agent), нет в списке GET agent */
  active?: boolean;
  bic: string;
  checkingAccount: string;
  createDate: string;
  fioEio: string;
  fullName: string;
  id: string;
  inBank: string;
  inn: string;
  kpp: string;
  location: string;
  manager: any;
  managerEmail: string;
  managerPhone: string;
  ogrn: string;
  positionEio: string;
  shortName: string;
  tariff1: string;
  tariff2: string;
  tariff3: string;
  // тарифы 4-6 есть не у всех агентов
  tariff4?: string;
  tariff5?: string;
  tariff6?: string;
  contractDate: string;
  contractNumber: string;
}

interface IIndividual2 {
  id: string;
  fio: string;
  name: string;
  surname: string;
  parname: string;
  chief: boolean;
  initials: string;
  initialsShort: string;
}
class Individual2 implements IIndividual2 {
  'id' = '';
  'fio' = '';
  'name' = '';
  'surname' = '';
  'parname' = '';
  'chief' = false;
  'initials' = '';
  'initialsShort' = '';
}

interface IHead {
  present: true;
}

/** Метаинформация заявки: набор ключей зависит от заявки, все необязательные (строки 'true'/'false' и т.п.) */
interface IMetainfo {
  actualAddressMatch?: string;
  inviteManager?: string;
  passedStage?: string;
  notifyByEmail?: string;
  notifyByPhone?: string;
  /** служебные ключи, например "clientDocumentsReadyNotification.<id>.sentCount" */
  [key: string]: string | undefined;
}
class Metainfo implements IMetainfo {
  [key: string]: string | undefined;
  'actualAddressMatch' = '';
  'inviteManager' = '';
  'passedStage' = '';
  'notifyByEmail' = '';
  'notifyByPhone' = '';
}

export interface IChecks {
  [key: string]: IChecksApp;
}
export interface IChecksApp {
  id: string;
  title: string;
  type: string;
  checks: IChecksNesting;
}
interface IChecksNesting {
  [key: string]: IChecksData[];
}
export interface IChecksData {
  group: IChecksDataGroup;
  checks: IChecksDataChecks[];
}
export interface IChecksDataGroup {
  id: number;
  name: string;
  sort: number;
  deleted: boolean;
  canDelete: boolean;
  failColorMode: string;
  allFailColor: boolean;
  mode?: string;
  color?: string;
}
export interface IChecksDataChecks {
  id: IChecksDataCheckId;
  modifytime: string;
  result: string;
  verifier: string;
  groupid: number;
  status: string;
  checkDict: ICheckDict;
  payload: IPayload;
  binaryInfo: IBinaryInfo;
  changeable: boolean;
  diffLast: boolean;
  valid: boolean;
  typeEnum: string;
  comment: string;
  checkColor?: string;
  iid?: number;
}
interface IChecksDataCheckId {
  objectId: string;
  executetime: string;
  checktype: number;
}
interface ICheckDict {
  id: number;
  checkOptions: ICheckOptions[];
  checkVariables: ICheckVariables[];
  severity: string;
  type: string;
  name: string;
  individual: boolean;
  legalentity: boolean;
  disabled: boolean;
  deleted: boolean;
  counterparty: boolean;
  autoRejection: boolean;
  groupid: number;
  systemid: number;
  ordernum: number;
  group: ICheckDictGroup;
  optionMap: IoptionMap;
  variableMap: IVariableMap;
  uploadFile: boolean;
}
export interface ICheckOptions {
  id: ICheckOptionsId;
  text: string;
}
interface ICheckOptionsId {
  id: number;
  status: string;
}
interface ICheckVariables {
  id: ICheckVariablesId;
  value: string;
  type: string;
  key: string;
}
interface ICheckVariablesId {
  id: number;
  key: string;
}
interface ICheckDictGroup {
  id: number;
  name: string;
  sort: number;
  deleted: boolean;
  canDelete: boolean;
  failColorMode: string;
  allFailColor: boolean;
}
interface IoptionMap {
  STATE_FAIL: string;
  STATE_EXTERNAL_ERROR: string;
  STATE_OK: string;
  STATE_UNDEFINED: string;
  STATE_IN_PROGRESS: string;
}
/** Переменные проверки по кодам (URL_INTERNAL_API, CONTOUR_FOCUS_URL и т.д.) - набор зависит от проверки */
interface IVariableMap {
  [code: string]: IDataValue;
}
interface IDataId {
  id: number;
  key: string;
}
interface IDataValue {
  id: IDataId;
  value: string;
  type: string;
  key: string;
}
export interface IPayload {
  [key: string]: any;
  notes4staff: string;
  description: string;
  applications: string;
  status: string;
  stakeholders: string;
  accstoppedlist: string;
  ageStakeholders: string;
  companyList: string;
  founders: string;
}
export interface ICompanyList {
  inn: string;
  name: string;
  address: string;
}
export interface IApplicationsArr {
  id: number;
  inn: string;
  orgName: string;
  number: number;
  createDate: string;
  client: string;
  status: string;
}
export interface ICronosArr {
  id: string;
  fio: string;
  color?: string;
  status?: string;
  result: string;
}
export interface IAgeStakeholders {
  dateBirth: string;
  fio: string;
  position: string;
  share?: string;
  age: number | string;
  status: string;
}
export interface IFounders {
  fio: string;
  inn: string;
  name: string;
  registerDate: string;
  status: string;
  registerAddress: string;
  share?: string;
  founderName: string;
}

export interface IAccstoppedlist {
  NOMER: string;
  DATA: string;
  KODOSNOV: string;
  IFNS: string;
  BIK: string;
  DATABI: string;
}

export interface INotes4staff {
  [key: string]: string;
}
export interface INotes4staffTable {
  typeChecks: string;
  message: string;
  color: string;
}
export interface IStakeholdersPayload {
  name?: string;
  series?: string;
  number?: number;
  status?: string;
  msgInnCft?: string;
  color: string;
}
interface IBinaryInfo {
  id: string;
  name: string;
  mimetype: string;
  createDate: string;
}

export interface IDetailHistory {
  id: string;
  applicationId: string;
  dateTime: string;
  fieldId: string;
  fieldName: string;
  oldValue: string;
  newValue: string;
  typeField: string;
  chapter: string;
  moreDetails: string;
}

export interface ISectionDetail {
  name: string;
  blocks: ISectionDetail[];
  fields: IDetailHistory[];
}

/** Запись истории заявки: applicationId и dateTime - на верхнем уровне (не в id, как думали раньше) */
export interface IAppHistories {
  applicationId: string;
  dateTime: string;
  initiator: string;
  event: string;
  role: string;
  comment: string;
  /** нет у системных событий (смена статуса автоматом) */
  lkbUserId?: string;
  questionnaireHistories?: IDetailHistory[];
  questionnaireHistory: boolean;
  referralLink?: string;
}
export interface IBuildRowName {
  text: string;
  link: string;
}

interface IBinaryInfoClients {
  /*"111": [],
    "Приказ о вступлении в должность Единоличного Исполнительного Органа": [],
    "Протокол (решение) об избрании Единоличного Исполнительного Органа": [],
    "Паспорт": [],
    "test./,type": [],
    "Документы, удостоверяющие личности лиц, указанных в карточке с образцами подписей и оттиском печати, и лиц действующих по доверенности от имени юридического лица": [],
    "Документы, подтверждающие финансовое положение юридического лица": [],
    "Документы, удостоверяющие личности лиц, указанных в карточке с образцами подписей и оттиском печати, и лиц действующих по доверенности от имени юридического лица*": [],
    "Протокол (Решение) общего собрания учредителей/Акционеров о создании (об учреждении – для обществ с ограниченной ответственностью) юридического лица – Клиента*": [],
    "Учредительные документы": [],
    "Документы, подтверждающие полномочия лиц, указанных в карточке с образцами подписей и оттиском печати, на распоряжение денежными средствами, находящимися на банковском счете": [],
    "666 Документы, удостоверяющие личности лиц, указанных в карточке с образцами подписей и оттиском печати, и лиц действующих по доверенности от имени юридического лица*": [],
    "222 Учредительные документы": []*/
  [key: string]: any[];
}

export interface IAction {
  name: string;
  action: string;
  type: string;
  automaticExitFromApplication?: boolean;
}
export interface IApplication {
  id: string;
  number: number;
  auto: boolean;
  directLink?: any;
  utmSource?: any;
  utmMedium?: any;
  utmCampaign?: any;
  actualAddressObject?: IData; //dadata
  regAddressObject: IData; //dadata
  clientinternalid?: number;
  regaddress: string;
  regagency?: string;
  /** нет у заявок ИП/физлиц без фактического адреса */
  actualaddress?: string;
  regdate: string;
  createdate: string;
  modifydate: string;
  lifedate: string;
  orgnameshort: string;
  orgnamefull: string;
  orgnamealien: string;
  inn: string;
  kpp: string;
  ogrn?: string;
  okpo: string;
  okfs: string;
  okogu?: string;
  okopf: string;
  oktmo?: string;
  comment?: string;
  stage: string;
  stagedescription: string;
  /** только у юрлиц */
  authorizedcapital?: number;
  finalized: boolean;
  writeBankForm: boolean;
  okopfcode?: string;
  regionFromRegAddress?: string;
  legalForm: IData;
  okved: IOkved;
  okato: IOkato;
  ownershipForm: IOwnershipForm;
  integrumId: number;
  counterparties: IItemCounterparties[];
  bankoffice?: IBankoffice;
  stakeholders: IStakeholders[];
  type: IType;
  statusHistoryList: IStatusHistoryList[];
  signatureList: ISignatures[];
  requirements: [];
  metaInfoList: IMetaInfoList[];
  agent?: IAgent;
  client: IClient;
  licenses: ILicense[];
  actualStatus: IStatus;
  actualRealStatus: IStatus;
  numberInvoice?: string;
  cardAccount?: string;
  currencyInvoice?: [];
  remainingDays: number;
  controlEvents?: [];
  objectId: string;
  head: IHead | null;
  currency: boolean;
  innEnum: string;
  applicationNumber: string;
  metainfo: IMetainfo;
  empty: boolean;
  rafp: boolean;
  additionalActualAddress?: string;
  clientABSNumber?: string;
  additionalNotificationInfo?: {
    id: string | null | undefined;
    fio?: string | null;
    emails: string[];
  };
  dateOfBirth?: string;
  borrowerFl?: string;
  lastDate?: string;
  reportDate?: string;
  deletedPersonalInfoFromApplication: boolean;
  applicationRequestType?: string;
  clientStatusDisplay?: string | null;
  signers?: IData[];
  // поля ответа application/find, которых не было в типе (сверено со stage.cred)
  notactive: boolean;
  numberDBO: string;
  applicationAddresses: unknown[];
  /** nameRod - ФИО в родительном падеже, есть не у всех */
  signatories: { id: string; name: string; nameRod?: string }[];
  okveds: IOkved[];
  /** данные анкеты по кодам полей */
  companyInfoJson?: Record<string, string>;
  actualStatusId: number;
  agentApp: boolean;
  createdViaLkbLogin: boolean;
  /** код клиента в АБС - после передачи заявки в АБС */
  absCode?: string;
  keyClient?: number;
}

/** Лицензия организации */
interface ILicense {
  id: string;
  applicationId: string;
  officialNum: string;
  activity: string;
  dateEnd: string;
  issuerName: string;
  date: string;
}

interface IItemCounterparties {
  id: string;
  inn: string;
  name: string;
  factaddress: string;
}

/** Результат подготовки печатных форм банка (generatedBankDocResult) */
export interface IGeneratedBankDocResult {
  appId: string;
  role: string;
  fio: string;
  status: string;
  createDate: string;
}

export class App {
  application = <IApplication>{
    id: '',
    client: <IClient>new Client(),
    actualStatus: <IStatus>new Status(),
    innEnum: '',
    regaddress: '',
    regAddressObject: {},
    type: <IType>new Type(),
    metainfo: <IMetainfo>new Metainfo(),
    orgnameshort: '',
    regdate: '',
    authorizedcapital: 0,
    actualaddress: '',
    additionalActualAddress: '',
    directLink: '',
    utmSource: '',
    utmMedium: '',
    utmCampaign: '',
    inn: '',
    kpp: '',
    ogrn: '',
    okpo: '',
    okato: <IOkato>new Okato(),
    okved: <IOkved>new Okved(),
    comment: '',
  };
  signatures: ISignatures[] = [];
  callInfos = [];
  checks: IChecks = {};
  appHistories: IAppHistories[] = [];
  binaryInfoClients: IBinaryInfoClients = {};
  binaryInfoClientsRequirements = [];
  binaryInfoBankForms = {};
  actions: IAction[] = [];
  /** ROS-1525: подсказка по ветви, из которой заявка пришла в текущий статус; есть не у всех заявок */
  hintText?: string = '';
  finishStatus = false;
  /** результат подготовки печатных форм банка; нет, пока формы не готовили */
  generatedBankDocResult?: IGeneratedBankDocResult;
}
